<template>
    <div>
        <DuplicatedCustomerReferenceModal
            :customerReference="search_reference"
            @doContinueSameReference="continueSameReference"
            @doContinueDifferentReference="continueDifferentReference"
            @doCancelSearch="cancelSearchForSameCustomerReference"
        />
        <div class="card shadow-sm search-card">
            <div class="card-body">
                <div id="initial_inputs">
                    <div
                        class="field"
                        v-if="!isSearchDemo && [1, 2, 4, 20, 24].includes(getId)"
                    >
                        <input
                            id="switch_nsn"
                            type="checkbox"
                            name="switch_nsn"
                            class="switch is-rounded is-info"
                            v-model="is_nsn"
                            @change="emitUpdate"
                        />
                        <label v-if="is_nsn" for="switch_nsn" class="search-form-label-reset"
                            >NSN/NIIN</label
                        >
                        <label v-else for="switch_nsn" class="search-form-label-reset"
                            >Part Numbers</label
                        >
                    </div>
                    <div class="field" v-if="!isSearchDemo && hasSearchPartsPermission('gsa')">
                        <input
                            id="switch_gsa"
                            type="checkbox"
                            name="switch_gsa"
                            class="switch is-rounded is-info"
                            v-model="includeGSA"
                            @change="emitUpdate"
                        />
                        <label for="switch_gsa" class="search-form-label-reset">Include GSA</label>
                    </div>

                    <div class="search-form-textareas">
                        <textarea
                            id="parts_text"
                            class="textarea search-form-textarea search-form-textarea--parts"
                            rows="10"
                            placeholder="Part Number(s). Eg&#10;NYCOGN06&#10;DMNI50-2-2&#10;MS24665-151"
                            v-model="parts_text"
                            @input="updatePartsText"
                        ></textarea>
                        <textarea
                            v-if="!isSearchDemo"
                            id="qty_text"
                            class="textarea search-form-textarea search-form-textarea--qty"
                            rows="10"
                            placeholder="QTY. Eg&#10;3&#10;4&#10;2"
                            v-model="quantities_text"
                            @input="emitUpdate"
                        ></textarea>
                    </div>

                    <div v-if="isSearchDemo" class="search-form-control-rows">
                        <div class="field has-addons search-form-control-row">
                            <div class="control search-form-search-control search-form-search-control--demo">
                                <button
                                    id="search_button"
                                    class="button is-info search-form-search-button"
                                    type="button"
                                    @click="startSearch"
                                    :disabled="isSearchDisabled"
                                >
                                    Search
                                </button>
                            </div>
                        </div>
                    </div>
                    <div v-else class="search-form-control-rows">
                        <div class="field has-addons search-form-control-row">
                            <div class="control is-expanded input-spinner-container">
                                <input
                                    id="search_reference"
                                    class="input"
                                    type="text"
                                    v-model="search_reference"
                                    placeholder="Reference Number"
                                    maxlength="40"
                                    @input="emitUpdate"
                                    @blur="
                                        validate_search_for_customer_reference_exists(search_reference)
                                    "
                                />
                                <div
                                    v-if="isReferenceLoading"
                                    class="spinner-border text-danger input-spinner"
                                    role="status"
                                ></div>
                            </div>
                            <div class="control search-form-type-control">
                                <div class="select">
                                    <select
                                        id="search_type"
                                        v-model="search_type"
                                        @change="emitUpdate"
                                    >
                                        <option
                                            disabled
                                            hidden
                                            value=""
                                            class="search-form-placeholder-option"
                                        >
                                            Type
                                        </option>
                                        <option value="Quote">Quote</option>
                                        <option value="AOG">AOG</option>
                                        <option value="Research">Research</option>
                                        <option disabled hidden value="Batch">Batch</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="field has-addons search-form-control-row">
                            <div class="control is-expanded">
                                <InputSelectDropdown
                                    v-if="isRetail"
                                    :model-value="search_customer"
                                    input-id="search_customer"
                                    select-id="search_customer_select"
                                    :options="customers"
                                    :select-size="6"
                                    input-class="input customer-select"
                                    select-class="form-select form-select-sm customer-select-dropdown"
                                    :input-attrs="{ autocomplete: 'off', placeholder: 'Customer' }"
                                    @update:modelValue="handleCustomerUpdate"
                                />
                                <div v-else class="select search-form-select-wrap">
                                    <select
                                        v-model="search_customer"
                                        @change="emitUpdate"
                                        class="customer-select"
                                    >
                                        <option
                                            disabled
                                            hidden
                                            value=""
                                            class="search-form-placeholder-option"
                                        >
                                            Customer
                                        </option>
                                        <option
                                            v-for="(customer, index) in customers"
                                            :value="customer"
                                            :key="index"
                                        >
                                            {{ customer }}
                                        </option>
                                    </select>
                                </div>
                            </div>
                            <div class="control search-form-date-control">
                                <input
                                    ref="dueDateInput"
                                    id="search_due_date"
                                    class="input search-form-date"
                                    :class="{ 'search-form-date--empty': !due_date }"
                                    type="date"
                                    v-model="due_date"
                                    placeholder="Due Date"
                                    aria-label="Due Date"
                                    @click="openDueDatePicker"
                                    @focus="openDueDatePicker"
                                    @input="handleDueDateInput"
                                />
                                <span v-if="!due_date" class="search-form-date-placeholder">
                                    Due Date
                                </span>
                            </div>
                            <div class="control search-form-search-control">
                                <button
                                    id="search_button"
                                    class="button is-info search-form-search-button"
                                    type="button"
                                    @click="startSearch"
                                    :disabled="isSearchDisabled"
                                >
                                    Search
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapStores } from 'pinia'
    import { useUserStore } from '@/stores/userStore'
    import { useSubstitutesStore } from '@/stores/substitutesStore'
    import SearchService from '@/services/search.service'
    import config from '@/services/config'
    import DuplicatedCustomerReferenceModal from '../../components/modals/DuplicatedCustomerReferenceModal.vue'
    import InputSelectDropdown from '@/components/shared/InputSelectDropdown.vue'
    import { Modal } from 'bootstrap'

    export default {
        name: 'SearchForm',
        components: {
            DuplicatedCustomerReferenceModal,
            InputSelectDropdown,
        },
        props: {
            initialData: {
                type: Object,
                default: () => ({}),
            },
            customers: {
                type: Array,
                default: () => [],
            },
        },
        data() {
            return {
                is_nsn: this.initialData.is_nsn || false,
                includeGSA: this.initialData.includeGSA || false,
                parts_text: this.initialData.parts_text || '',
                quantities_text: this.initialData.quantities_text || '',
                search_reference: this.initialData.search_reference || '',
                search_type: this.initialData.search_type || '',
                search_customer: this.initialData.search_customer || '',
                due_date: this.initialData.due_date || '',
                isReferenceLoading: false,
            }
        },
        computed: {
            ...mapStores(useUserStore, useSubstitutesStore),
            getId() {
                return this.userStore.getId
            },
            dashboardPermissions() {
                return this.userStore.dashboardPermissions
            },
            isRetail() {
                return config.isRetail ? config.isRetail() : config.getSubdomain() === 'retail'
            },
            isSearchDemo() {
                return config.isSearchDemo ? config.isSearchDemo() : false
            },
            parsedPartsLines() {
                return (this.parts_text || '')
                    .split(/\r?\n/)
                    .map((line) => line.trim())
                    .filter((line) => line !== '')
            },
            parsedQuantitiesLines() {
                if (this.isSearchDemo) {
                    return this.parsedPartsLines.map(() => '1')
                }

                const lines = (this.quantities_text || '').split(/\r?\n/).map((line) => line.trim())

                while (lines.length > 0 && lines[lines.length - 1] === '') {
                    lines.pop()
                }

                return lines
            },
            isSearchDisabled() {
                const isReferenceLoading = !this.isReferenceLoading
                const hasParts = this.parsedPartsLines.length > 0
                const hasValidQuantities =
                    this.parsedQuantitiesLines.length === this.parsedPartsLines.length &&
                    this.parsedQuantitiesLines.every((line) => line !== '')

                if (this.isSearchDemo) {
                    return !(hasParts && hasValidQuantities)
                }

                const referenceStripped = (this.search_reference || '').replace(/\s+/g, '')
                const hasReference = referenceStripped.length >= 3
                const hasType = Boolean(this.search_type)
                const hasCustomer = Boolean(this.search_customer)

                return !(
                    hasParts &&
                    hasReference &&
                    hasType &&
                    hasCustomer &&
                    hasValidQuantities &&
                    isReferenceLoading
                )
            },
        },
        methods: {
            async validate_search_for_customer_reference_exists(customerReference) {
                if (this.isSearchDemo) {
                    return
                }
                if (!customerReference || customerReference.trim().length < 3) {
                    return
                }
                this.isReferenceLoading = true
                let is_existing_reference
                try {
                    is_existing_reference =
                        await SearchService.check_search_action_exists_for_customer_reference(
                            customerReference
                        )
                    if (is_existing_reference === true) {
                        this.openModal('duplicatedCustomerReferenceModal')
                    }
                } catch (e) {
                    console.log('Error validating customer reference:', e)
                } finally {
                    this.isReferenceLoading = false
                }
            },
            openModal(modalId) {
                const modalElement = document.getElementById(modalId)
                if (modalElement) {
                    const modal = Modal.getInstance(modalElement) || new Modal(modalElement)
                    modal.show()
                }
            },
            closeModal(modalId) {
                const modalElement = document.getElementById(modalId)
                if (modalElement) {
                    const modal = Modal.getInstance(modalElement) || new Modal(modalElement)
                    modal.hide()
                }
            },
            continueSameReference() {
                this.closeModal('duplicatedCustomerReferenceModal')
            },
            continueDifferentReference() {
                this.cleanFieldAndFocus('search_reference')
                this.closeModal('duplicatedCustomerReferenceModal')
            },
            cancelSearchForSameCustomerReference() {
                this.cleanForm()
                this.closeModal('duplicatedCustomerReferenceModal')
            },
            focusField(fieldId) {
                this.$nextTick(() => {
                    const field = this.$el.querySelector(`#${fieldId}`)
                    if (field) {
                        field.focus()
                    }
                })
            },
            cleanFieldAndFocus(fieldName) {
                this[fieldName] = fieldName === 'is_nsn' || fieldName === 'includeGSA' ? false : ''
                this.emitUpdate()
                this.focusField(fieldName === 'parts_text' ? 'parts_text' : 'search_reference')
            },
            cleanForm() {
                this.is_nsn = false
                this.includeGSA = false
                this.parts_text = ''
                this.quantities_text = ''
                this.search_reference = ''
                this.search_type = ''
                this.search_customer = ''
                this.due_date = ''
            },
            emitUpdate() {
                this.$emit('update', {
                    is_nsn: this.is_nsn,
                    includeGSA: this.includeGSA,
                    parts_text: this.parts_text,
                    quantities_text: this.isSearchDemo
                        ? this.parsedQuantitiesLines.join('\n')
                        : this.quantities_text,
                    search_reference: this.isSearchDemo
                        ? this.getDemoReference()
                        : this.search_reference,
                    search_type: this.isSearchDemo ? 'Research' : this.search_type,
                    search_customer: this.isSearchDemo ? 'Search Demo' : this.search_customer,
                    due_date: this.due_date || null,
                })
            },
            updatePartsText(event) {
                this.parts_text = event.target.value.toUpperCase()
                this.emitUpdate()
            },
            handleCustomerUpdate(customer) {
                this.search_customer = customer
                this.emitUpdate()
            },
            handleDueDateInput() {
                this.emitUpdate()
            },
            openDueDatePicker(event) {
                const input = event?.currentTarget || this.$refs.dueDateInput

                if (input && typeof input.showPicker === 'function') {
                    try {
                        input.showPicker()
                    } catch (error) {
                        // Some browsers only allow showPicker from direct pointer activation.
                    }
                }
            },
            startSearch() {
                if (this.isSearchDemo) {
                    this.emitUpdate()
                }
                this.$emit('trigger-search')
            },
            getDemoReference() {
                if (this.search_reference) {
                    return this.search_reference
                }
                const timestamp = new Date().toISOString().replace(/[-:.TZ]/g, '').slice(0, 14)
                this.search_reference = `DEMO-${timestamp}`
                return this.search_reference
            },
            hasSearchPartsPermission(option) {
                let permissions = this.dashboardPermissions
                let response = false

                if (permissions.length < 1) {
                    return response
                }

                return permissions.some((permission) => permission.vendor === option)
            },
        },
    }
</script>

<style scoped>
    .search-card {
        border: 1px solid var(--color-border-muted);
        border-top: 4px solid var(--color-brand-primary);
        border-radius: var(--radius-lg);
        background: var(--color-surface-canvas);
        box-shadow: var(--shadow-sm);
    }

    .search-form-label-reset {
        outline: none;
        color: var(--color-text-secondary);
    }

    .search-form-textareas {
        display: flex;
        width: 100%;
    }

    .search-form-textarea {
        display: inline-block;
        max-width: none;
        min-width: 0;
        height: 150px;
        background: var(--color-surface-canvas);
        color: var(--color-text-primary);
        border-color: var(--color-border-muted);
    }

    .search-form-textarea--parts {
        flex: 1;
    }

    .search-form-textarea--qty {
        width: 6em;
        white-space: pre;
    }

    .search-form-control-rows {
        display: flex;
        flex-direction: column;
        width: 100%;
    }

    .search-form-control-row {
        margin-bottom: 0;
        width: 100%;
    }

    .search-form-control-row + .search-form-control-row {
        margin-top: -1px;
    }

    .search-form-control-row:first-child .input,
    .search-form-control-row:first-child .select select {
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
    }

    .search-form-control-row:last-child .input,
    .search-form-control-row:last-child .select select,
    .search-form-control-row:last-child .button {
        border-top-left-radius: 0;
        border-top-right-radius: 0;
    }

    .search-form-type-control {
        flex: 0 0 19rem;
        min-width: 19rem;
    }

    .search-form-select-wrap {
        width: 100%;
    }

    .search-form-date {
        width: 12.5rem;
        cursor: pointer;
    }

    .search-form-date-control {
        position: relative;
    }

    .search-form-search-button {
        height: 100%;
        width: 100%;
    }

    .search-form-search-control {
        flex: 0 0 6.5rem;
    }

    .search-form-search-control--demo {
        flex: 0 0 10rem;
    }

    .search-form-date--empty {
        color: transparent !important;
    }

    .search-form-date-placeholder {
        position: absolute;
        top: 50%;
        left: 0.75rem;
        line-height: 1;
        color: var(--color-text-muted);
        pointer-events: none;
        transform: translateY(-50%);
    }

    .search-form-placeholder-option {
        color: var(--color-text-muted);
    }

    .input-spinner-container .input,
    .select select,
    .customer-select,
    .search-form-date {
        border-color: var(--color-border-muted);
        color: var(--color-text-primary);
        background: var(--color-surface-canvas);
    }

    .search-form-textarea::placeholder,
    .input-spinner-container .input::placeholder,
    .search-form-date::placeholder,
    .select select:invalid,
    .customer-select:invalid {
        color: var(--color-text-muted);
    }

    .input-spinner-container .input:focus,
    .select select:focus,
    .customer-select:focus,
    .search-form-date:focus,
    .search-form-textarea:focus {
        border-color: var(--color-border-accent-strong);
        box-shadow: var(--shadow-focus-brand);
    }
</style>

<style scoped lang="scss">
    #initial_inputs {
        display: flex;
        flex-direction: column;
        margin-top: 3em;
        margin: 0 auto;
        max-width: 750px;
    }
    .search-card {
        max-width: 700px;
        margin: 0 auto;
    }
    .customer-select {
        width: inherit;
    }
    .search-form-control-row .control.is-expanded,
    .search-form-control-row .input-select-dropdown,
    .search-form-control-row .select,
    .search-form-control-row .select select,
    .search-form-control-row .customer-select {
        width: 100%;
    }
    .input-spinner-container {
        position: relative;
    }
    .input-spinner {
        position: absolute;
        top: 25%;
        right: 0.75em;
        width: 1.5em;
        height: 1.5em;
    }
</style>
